import { render, staticRenderFns } from "./BidDirectorApproval.vue?vue&type=template&id=0621f47a&"
import script from "./BidDirectorApproval.vue?vue&type=script&lang=js&"
export * from "./BidDirectorApproval.vue?vue&type=script&lang=js&"
import style0 from "./BidDirectorApproval.vue?vue&type=style&index=0&id=0621f47a&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports